type DeSerializedId = {
  id: number;
  type: string;
};

export const extractEntityIdField = (serializedId: string): number => {
  try {
    const idObject = JSON.parse(serializedId) as DeSerializedId;

    return idObject.id;
  } catch (e) {
    return 0;
  }
};
